module.exports = __webpack_public_path__ + "img/gigabot-parse-cv.a5194426.gif";